import type { BodyUpdateTemplate } from "@/common/types/notesTemplates";
import { useUpdateNoteTemplate } from "./useUpdateNoteTemplate";
import { useUpdateVisitTemplate } from "../visitsTemplates/useUpdateVisitTemplate";

export interface IUseUpdateTemplate {
  updateTemplate: (body: BodyUpdateTemplate) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
}

export enum UseUpdateTemplateType {
  VISIT = "visit",
  NOTE = "note",
}

export const useUpdateTemplateFactory = (
  type: UseUpdateTemplateType
): IUseUpdateTemplate => {
  const visitTemplate = useUpdateVisitTemplate();
  const noteTemplate = useUpdateNoteTemplate();

  switch (type) {
    case UseUpdateTemplateType.VISIT:
      return visitTemplate;
    case UseUpdateTemplateType.NOTE:
      return noteTemplate;
    default:
      throw new Error("Unknown type");
  }
};
